import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ptg-input-number-mask',
  templateUrl: './input-number-mask.component.html',
  styleUrls: ['./input-number-mask.component.scss']
})
export class InputNumberMaskComponent implements OnInit {
  @Input() controlField!: AbstractControl | any;
  @Input() placeholder!: string;
  @Input() errorRequire?: string;
  @Input() errorPattern?: string;
  @Input() errorAsync?: string;
  @Input() errorMaxLength?: string;
  @Input() errorMin?: string;
  @Input() errorMax?: string;
  @Input() errorBetween?: string;
  @Input() maxLength?: number;
  @Input() hasLabel?: boolean;
  @Input() isDisabled?: boolean;
  @Input() class?: string;
  @Input() min?: string;
  @Input() max?: string;
  @Input() mask: string = 'separator';
  @Input() thousandSeparator: string = '';
  @Input() allowNegativeNumbers: boolean = true;
  @Input() isAutoLeadingZeros: boolean = false;
  @Input() isValidation: boolean = true;
  @Input() isPercentage?: boolean;

  constructor() { }

  ngOnInit(): void { 
  }

  onFocusOut(event: any) {
    const val = event.target.value;
    // Auto leading zeros by maxlength
    if (this.isAutoLeadingZeros && this.maxLength && this.maxLength > 0 && val && val?.trim() !== '') {
      this.controlField.setValue(('0'.repeat(this.maxLength) + val).slice(-Math.abs(this.maxLength)));
    }

    if (this.isPercentage && this.controlField.value && this.controlField.value.endsWith('.')) {
      this.controlField.setValue(this.controlField.value.substring(0, this.controlField.value.length - 1));
    }
  }
}
